import { ReactNode } from 'react';
import { Clickable } from 'components/common/Clickable';
import { Spinner } from 'components/common/Spinner';

import styles from './styles.module.css';

type Color = 'accent' | 'premium'

type Props = {
    className?: string;
    children?: ReactNode;
    onClick?(e: React.MouseEvent<HTMLButtonElement>): void;
}

type TintButtonProps = {
    color?: Color
} & Props

export const TintButton: React.FC<TintButtonProps> = ({
    className,
    children,
    color,
    onClick,
}) => {
    const coloredClassName = (() => {
        switch (color) {
            case 'accent':
                return styles.tintAccent
            case 'premium':
                return styles.tintPremium
            default:
                return styles.tintAccent
        }
    })()
    const commonClassName = `${styles.common} ${coloredClassName}`
    const _className = className ? `${className} ${commonClassName}` : `${commonClassName}`
    return (
        <Clickable
            className={_className}
            type='item'
            onClick={onClick}>
            {children}
        </Clickable>
    )
}

type LoadableButtonProps = {
    isLoading: boolean
} & Props

export const LoadableButton: React.FC<LoadableButtonProps> = ({
    className,
    children,
    isLoading,
    onClick,
}) => {
    const commonClassName = `${styles.common} ${styles.tintAccent}`
    const _className = className ? `${className} ${commonClassName}` : `${commonClassName}`
    return (
        <Clickable
            disabled={isLoading}
            className={_className}
            type='item'
            onClick={onClick}>
            { isLoading && <Spinner className={ styles.spinner } size={ 16 } /> }
            {children}
        </Clickable>
    )
}

export const BorderButton: React.FC<Props> = ({
    className,
    children,
    onClick,
}) => {
    const _className = `${className || ""} ${styles.common} ${styles.border}`
    return (
        <Clickable
            className={_className}
            type='item'
            onClick={onClick}>
            {children}
        </Clickable>
    )
}
